import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#6DA544",
  d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#FFDA44",
  d: "m18.42 17.218.33.688.743-.171-.333.686.598.474-.745.168.002.764-.595-.478-.596.477.002-.763-.744-.168.598-.474-.333-.686.744.171zM15.357 9.912l.33.689.743-.172-.333.687.598.474-.744.168.002.763-.596-.477-.595.477.002-.763-.744-.168.598-.474-.334-.687.744.172zM18.42 5.738l.33.689.743-.172-.333.687.598.474-.745.168.002.763-.595-.478-.596.478.002-.763-.744-.168.598-.474-.333-.687.743.172zM21.096 8.87l.329.689.744-.172-.333.687.598.474-.745.168.002.763-.595-.477-.596.477.002-.763-.744-.168.598-.474-.333-.687.743.172zM19.183 12.521l.26.797h.837l-.678.493.26.797-.679-.492-.678.492.259-.797-.678-.493h.838z"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#FFDA44",
  d: "M13.306 15.391a3.391 3.391 0 1 1 1.614-6.375 4.174 4.174 0 1 0 0 5.967c-.48.26-1.03.408-1.614.408M7.548 4.696a2.086 2.086 0 0 0-3.614 0zM7.553 4.708 5.74 6.522 3.925 4.708a2.087 2.087 0 1 0 3.628 0"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#A2001D",
  d: "M5.219 6v1.76a2.1 2.1 0 0 0 1.043 0V6z"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_6]))
}
export default { render: render }